import React from 'react'
import Modal from 'react-modal'
import Box from '@mui/material/Box'
import textNoSelect from 'assets/theme/textNoSelect'
import classes from './GpdrModal-CSS'
import { Button, Typography } from '@mui/material'
import { useTranslation } from 'next-i18next'

type Props = {
  show: boolean
  onAccept: () => void
}

export default function GpdrModal(props: Props) {
  const { t } = useTranslation('common')

  const customStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
      zIndex: 2000
    },
    content: {
      position: 'fixed' as const,
      height: 'auto',
      width: 500,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      padding: 0,
      background: '#fff',
      border: '1px solid #ccc',
      boxShadow: '0px -3px 7px 0px #ccc'
    }
  }

  const renderContent = () => (
    <Box
      sx={{
        ...classes.mainDiv,
        display: 'flex',
        flexDirection: 'column',
        padding: 3,
        width: '100%',
        ...textNoSelect
      }}
    >
      <Typography variant="h6" sx={{ color: '#454749', mb: 1 }}>
        {t('gpdr.message1')}
      </Typography>

      <Box sx={classes.divider} />

      <Typography variant="body1" sx={{ color: '#454749', mb: 1 }}>
        {t('gpdr.message2')}
      </Typography>
      <Typography variant="body2" sx={{ color: '#454749', mb: 2 }}>
        {t('gpdr.message3')}
        <a
          target="_blank"
          href="https://kroemtech.ch/en/terms-of-use/"
          style={{ ...classes.link, textDecoration: 'none' }}
        >
          {t('gpdr.link1')}{' '}
        </a>
        {t('gpdr.message4')}{' '}
        <a
          target="_blank"
          href="https://kroemtech.ch/en/privacy/"
          style={{ ...classes.link, textDecoration: 'none' }}
        >
          {t('gpdr.link2')}
        </a>{' '}
        .
      </Typography>

      <Box sx={classes.divider} />

      {/* Action Buttons */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 1,
          mt: 0.5,
          flexWrap: 'wrap'
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{ borderRadius: 0 }}
          onClick={props.onAccept}
        >
          I AGREE
        </Button>
      </Box>
    </Box>
  )

  return (
    <Modal
      isOpen={props.show}
      ariaHideApp={false}
      style={customStyles}
      className="mymodal"
      closeTimeoutMS={200}
    >
      {renderContent()}
    </Modal>
  )
}
